webpackJsonp([25],{

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_kanbansuffix_js__ = __webpack_require__(1377);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb1c2a4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kanbansuffix_vue__ = __webpack_require__(1631);
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_kanbansuffix_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb1c2a4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kanbansuffix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_kanbansuffix__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_kbsetup_edit_modal__ = __webpack_require__(1629);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kanbansuffix',
  components: {
    kbseditmodal: __WEBPACK_IMPORTED_MODULE_2__components_modal_kbsetup_edit_modal__["a" /* default */]
  },
  data: function data() {
    return {
      search_text: '',
      dk_id: '',
      dk_code: '',
      dockList: [],
      pr_number: '',
      partList: [],
      pr_id_number: '',
      partidList: [],
      spl_plant_code: '',
      plantList: [],
      spl_id: '',
      spl_code: '',
      supplierList: [],
      ps_qty_pack: '',
      is_active: 1,
      isLoad: false,
      result_data: [],
      str_data: '',
      aisin: 0,
      read: 0,
      ordered: 0,
      current: 0,
      setup: 0,
      kbwait: 0,
      remarkList: [],
      prs_remark: '',
      // form
      ps_id: '',
      prs_ids: [],
      md_data: {
        ps_id: 0,
        aisin: 0,
        read: 0,
        ordered: 0,
        current: 0,
        setup: 0
      }
    };
  },
  created: function created() {
    this.checkOAuth();
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.pr_id = _this.$route.query.pr_id !== undefined ? _this.$route.query.pr_id : _this.pr_id;
      _this.pr_number = _this.$route.query.pr_number !== undefined ? _this.$route.query.pr_number : _this.pr_number;
      _this.pr_id_number = _this.$route.query.pr_id_number !== undefined ? _this.$route.query.pr_id_number : _this.pr_id_number;
      _this.ps_id = _this.$route.query.ps_id !== undefined ? _this.$route.query.ps_id : _this.ps_id;
      _this.ps_qty_pack = _this.$route.query.ps_qty_pack !== undefined ? _this.$route.query.ps_qty_pack : _this.ps_qty_pack;
      _this.plant_code = _this.$route.query.plant_code !== undefined ? _this.$route.query.plant_code : _this.plant_code;
      _this.spl_id = _this.$route.query.spl_id !== undefined ? _this.$route.query.spl_id : _this.spl_id;
      _this.spl_code = _this.$route.query.spl_code !== undefined ? _this.$route.query.spl_code : _this.spl_code;
      _this.spl_name = _this.$route.query.spl_name !== undefined ? _this.$route.query.spl_name : _this.spl_name;
      _this.spl_plant_code = _this.$route.query.spl_plant_code !== undefined ? _this.$route.query.spl_plant_code : _this.spl_plant_code;
      _this.dk_id = _this.$route.query.dk_id !== undefined ? _this.$route.query.dk_id : _this.dk_id;
      _this.dk_code = _this.$route.query.dk_code !== undefined ? _this.$route.query.dk_code : _this.dk_code;
      if (sessionStorage.token) {
        _this.getRemark();
        _this.search();
      } else {
        setTimeout(function () {
          _this.getRemark();
          _this.search();
        }, 1000);
      }
    }, 1000);
  },

  methods: {
    backTopage: function backTopage() {
      this.$router.push({
        name: 'Suffixsearch',
        params: {
          dock: typeof this.$route.query.dk_id !== 'undefined' ? this.$route.query.dk_id : '',
          part: typeof this.$route.query.pr_id !== 'undefined' ? this.$route.query.pr_id : ''
        }
      });
    },
    search: function search() {
      var _this2 = this;

      this.isLoad = true;
      this.aisin = 0;
      this.read = 0;
      this.ordered = 0;
      this.current = 0;
      this.setup = 0;
      this.prs_ids = [];
      this.md_data = {
        ps_id: 0,
        aisin: 0,
        read: 0,
        ordered: 0,
        current: 0,
        setup: 0
      };
      var obj = {
        ps_id: this.ps_id,
        dk_id: this.dk_id,
        pr_number: this.pr_number,
        pr_id_number: this.pr_id_number,
        prs_inout: this.is_active,
        spl_plant_code: this.spl_plant_code,
        spl_id: this.spl_id,
        ps_qty_pack: this.ps_qty_pack
      };
      this.result_data = [];
      this.header.params = obj;
      if (this.part !== '' || this.partid !== '') {
        __WEBPACK_IMPORTED_MODULE_0__models_kanbansuffix__["a" /* default */].Reportallpartserial(this.$store.state.URLHost, this.header, function (result) {
          if (result.response === true) {
            _this2.result_data = result.data;
            _this2.aisin = result.aisin;
            _this2.read = result.read;
            _this2.ordered = result.ordered;
            _this2.current = result.current;
            _this2.setup = result.setup;
            _this2.md_data = {
              ps_id: _this2.ps_id,
              aisin: _this2.aisin,
              read: _this2.read,
              ordered: _this2.ordered,
              current: _this2.current,
              setup: _this2.setup
            };
            _this2.getKBWait();
          } else {
            _this2.alert_msg('warning', 'Kanban Suffix Search', result.message);
          }
          _this2.isLoad = false;
        }, function (error) {
          _this2.alert_msg('error', 'Kanban Suffix Search', error.message);
          _this2.isLoad = false;
        });
      } else {
        this.alert_msg('warning', 'Kanban Suffix Search', 'Please select part number or part ID.');
        this.isLoad = false;
      }
    },
    getKBWait: function getKBWait() {
      var _this3 = this;

      this.header.params = {};
      this.kbwait = 0;
      __WEBPACK_IMPORTED_MODULE_0__models_kanbansuffix__["a" /* default */].getKanbanWait(this.$store.state.URLHost, this.ps_id, this.header, function (result) {
        if (result.response === true) {
          _this3.kbwait = result.sum_part_wait;
        } else {
          _this3.alert_msg('warning', 'Get Kanban Waiting', result.message);
        }
      }, function (error) {
        _this3.alert_msg('error', 'Get  Kanban Waiting', error.message);
      });
    },
    getRemark: function getRemark() {
      var _this4 = this;

      this.remarkList = [];
      this.header.params = {};
      __WEBPACK_IMPORTED_MODULE_0__models_kanbansuffix__["a" /* default */].getRemark(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this4.remarkList = result.data;
        } else {
          _this4.alert_msg('warning', 'Get Remark', result.message);
        }
      }, function (error) {
        _this4.alert_msg('error', 'Get Remark', error.message);
      });
    },
    updateRemark: function updateRemark(prs_id, prs_remark) {
      var _this5 = this;

      var formData = {
        prs_remark: prs_remark
      };
      this.header.params = {};
      __WEBPACK_IMPORTED_MODULE_0__models_kanbansuffix__["a" /* default */].updateRemark(this.$store.state.URLHost, formData, prs_id, this.header, function (result) {
        if (result.response === true) {
          _this5.search();
          _this5.alert_msg('success', 'Update Remark', result.message);
        } else {
          _this5.search();
          _this5.alert_msg('warning', 'An error occurred.', result.message);
        }
      }, function (error) {
        _this5.search();
        _this5.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    addStockOut: function addStockOut() {
      var _this6 = this;

      if (this.prs_ids.length > 0) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
          title: 'Are you sure?',
          text: 'Confirm add stock out : ' + this.prs_ids.length + ' part serial.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, do it!',
          cancelButtonText: 'Cancel'
        }).then(function (result) {
          if (result.value) {
            _this6.is_load = true;
            var formData = {
              ps_id: _this6.ps_id,
              prs_ids: _this6.prs_ids
            };
            __WEBPACK_IMPORTED_MODULE_0__models_kanbansuffix__["a" /* default */].addStockOut(_this6.$store.state.URLHost, formData, _this6.header, function (result) {
              if (result.response === true) {
                _this6.search();
                _this6.alert_msg('success', 'Add stock out', result.message);
              } else {
                _this6.search();
                _this6.alert_msg('warning', 'An error occurred.', result.message);
              }
            }, function (error) {
              _this6.search();
              _this6.alert_msg('error', 'An error occurred.', error.message);
            });
          }
        });
      } else {
        this.alert_msg('error', 'An error occurred.', 'Serial not selected.');
      }
    }
  }
});

/***/ }),

/***/ 1378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(511);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  GetDockAll: function GetDockAll(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/getdock', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  GetPartAll: function GetPartAll(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/getpart', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  GetPartAllID: function GetPartAllID(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/getpartid', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  GetPlantAll: function GetPlantAll(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/getplant', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSupplierAll: function getSupplierAll(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/getsupplier', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getRemark: function getRemark(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/getremark', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  Reportallpartserial: function Reportallpartserial(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/allpartserial', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateRemark: function updateRemark(URL, obj, Id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'kanbansuffix/updateremark/' + Id, obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addStockOut: function addStockOut(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbansuffix/addstockout', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getKanbanWait: function getKanbanWait(URL, psId, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/sumpartwaitadjust?ps_id=' + psId, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getKanbanSetupHistory: function getKanbanSetupHistory(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbansuffix/getpartsetuphistory', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateKanbanSetup: function updateKanbanSetup(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbansuffix/updatepartsetup', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_kanbansuffix__ = __webpack_require__(1378);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['md_data', 'search'],
  data: function data() {
    return {
      aisin: 0,
      read: 0,
      ordered: 0,
      current: 0,
      setup: 0,
      active_page: 1,
      per_page: 10,
      isLoad: false,
      result_data: {
        pagination: [],
        count: 0
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var myModalEl = document.getElementById('KBSEditModal');
    myModalEl.addEventListener('shown.bs.modal', function (event) {
      _this.getHistory();
      _this.aisin = _this.md_data.aisin;
      _this.read = _this.md_data.read;
      _this.ordered = _this.md_data.ordered;
      _this.current = _this.md_data.current;
      _this.setup = _this.md_data.setup;
      // eslint-disable-next-line no-undef
      $('#formEditKBSetup').removeClass('was-validated');
    });
  },

  methods: {
    checkForm: function checkForm() {
      var $myForm = $('#formEditKBSetup');
      if (!$myForm[0].checkValidity()) {
        $('#formEditKBSetup').addClass('was-validated');
      } else {
        this.updateKBSetup();
      }
    },
    itemRender: function itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous';
      } else if (type === 'next') {
        return 'Next';
      }
      return originalElement;
    },
    activePage: function activePage(value) {
      this.active_page = value;
      this.getHistory();
    },
    getHistory: function getHistory() {
      var _this2 = this;

      this.isLoad = true;
      var obj = {
        ps_id: this.md_data.ps_id,
        page: this.active_page,
        limit: this.per_page
      };
      this.result_data.pagination = [];
      this.result_data.count = 0;
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_1__models_kanbansuffix__["a" /* default */].getKanbanSetupHistory(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this2.result_data = result.data;
        } else {
          _this2.alert_msg('warning', 'Get Kanban Setup History', result.message);
        }
        _this2.isLoad = false;
      }, function (error) {
        _this2.alert_msg('error', 'Get Kanban Setup History', error.message);
        _this2.isLoad = false;
      });
    },
    updateKBSetup: function updateKBSetup() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
        title: 'Change Kanban Setup',
        text: 'You are changing Kanban Setup from ' + this.md_data.setup + ' to ' + this.setup + '. Want to continue ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#26AD0B',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then(function (result) {
        if (result.isConfirmed) {
          $('.preloader').fadeIn();
          $('#KBSEditModalclose').click();
          var obj = {
            ps_id: _this3.md_data.ps_id,
            new_current: _this3.setup
          };
          __WEBPACK_IMPORTED_MODULE_1__models_kanbansuffix__["a" /* default */].updateKanbanSetup(_this3.$store.state.URLHost, obj, _this3.header, function (result) {
            if (result.response === true) {
              _this3.search();
              _this3.alert_msg('success', 'Update Kanban Setup', result.message);
              $('.preloader').fadeOut();
            } else {
              _this3.search();
              _this3.alert_msg('warning', 'Update Kanban Setup', result.message);
              // eslint-disable-next-line no-undef
              $('.preloader').fadeOut();
            }
          }, function (error) {
            _this3.search();
            _this3.alert_msg('error', 'Update Kanban Setup', error.message);
            // eslint-disable-next-line no-undef
            $('.preloader').fadeOut();
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kbsetup_edit_modal_vue__ = __webpack_require__(1379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661db14b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kbsetup_edit_modal_vue__ = __webpack_require__(1630);
var normalizeComponent = __webpack_require__(509)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kbsetup_edit_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661db14b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kbsetup_edit_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"id":"formEditKBSetup"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Aisin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aisin),expression:"aisin"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.aisin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.aisin=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Read")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.read),expression:"read"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.read)},on:{"input":function($event){if($event.target.composing){ return; }_vm.read=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Ordered")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ordered),expression:"ordered"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.ordered)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ordered=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Total (Current)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current),expression:"current"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.current)},on:{"input":function($event){if($event.target.composing){ return; }_vm.current=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Setup")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.setup),expression:"setup"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.setup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.setup=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 d-flex align-items-center flex-column"},[_c('button',{staticClass:"btn btn-info btn-fix w-100 mb-2",attrs:{"type":"button","id":"act_btn","disabled":parseInt(this.md_data.setup) === parseInt(this.setup)},on:{"click":_vm.checkForm}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Save")]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('hr',{staticClass:"mt-1 mb-1"}),_vm._v(" "),_c('div',{staticClass:"table-responsive tableFixHead"},[_c('table',{staticClass:"table customize-table mb-0 v-middle"},[_vm._m(2),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.isLoad == true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),(_vm.result_data.pagination.length < 1 && _vm.isLoad == false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("No Data")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.result_data.pagination),function(rs,i){return _c('tr',{key:'rs' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.per_page * _vm.active_page - (_vm.per_page - i) + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n              "+_vm._s(_vm.dateFormatAndFulltime(rs.psu_create))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-end"},[_vm._v("\n              "+_vm._s(rs.psu_kanban_current)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(parseInt(rs.psu_active) === 1)?_c('span',{staticClass:"badge rounded-pill font-weight-medium bg-light-success text-success"},[_vm._v("Active")]):_vm._e(),_vm._v(" "),(parseInt(rs.psu_active) === 0)?_c('span',{staticClass:"badge rounded-pill font-weight-medium bg-light-danger text-danger"},[_vm._v("Expired")]):_vm._e()])])})],2)])]),_vm._v(" "),(parseInt(_vm.result_data.count) > parseInt(_vm.per_page) && _vm.isLoad == false)?_c('div',{staticClass:"text-end mt-3"},[_c('a-pagination',{staticStyle:{"cursor":"pointer"},attrs:{"pageSize":_vm.per_page,"total":_vm.result_data.count,"itemRender":_vm.itemRender},on:{"update:pageSize":function($event){_vm.per_page=$event},"update:page-size":function($event){_vm.per_page=$event},"change":_vm.activePage},model:{value:(_vm.active_page),callback:function ($$v) {_vm.active_page=$$v},expression:"active_page"}})],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"KBSEditModalLabel"}},[_vm._v("Edit Kanban Setup")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button","data-bs-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-fix w-100",attrs:{"type":"button","data-bs-dismiss":"modal","id":"KBSEditModalclose"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Close")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("No")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Create")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-end"},[_vm._v("Kanban Current Setup")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-lg-flex"},[_c('div',{staticClass:"col-sm-10"},[_c('h3',{staticClass:"card-title"},[_c('span',{staticClass:"lstick d-inline-block align-middle"}),_vm._v(_vm._s(_vm.$route.meta.title_sub !== '' ? _vm.$route.meta.title_sub : _vm.$route.meta.title))]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 text-end"},[_c('button',{staticClass:"btn waves-effect waves-light btn-secondary btn-sm btn-sm-fix",staticStyle:{"width":"48%"},on:{"click":_vm.backTopage}},[_c('i',{staticClass:"fa fa-arrow-left mr-1"}),_vm._v(" Back")])])]),_vm._v(" "),_c('div',{staticClass:"contianer"},[_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Part number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pr_number),expression:"pr_number"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.pr_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pr_number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Part ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pr_id_number),expression:"pr_id_number"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.pr_id_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pr_id_number=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Q'pack")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ps_qty_pack),expression:"ps_qty_pack"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.ps_qty_pack)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ps_qty_pack=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_active),expression:"is_active"}],staticClass:"form-select",attrs:{"name":"active"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.is_active=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.search()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("IN")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("OUT")]),_vm._v(" "),_c('option',{attrs:{"value":"99"}},[_vm._v("All")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Supplier")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_code),expression:"spl_code"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.spl_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Plant")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_plant_code),expression:"spl_plant_code"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.spl_plant_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_plant_code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2"},[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v("Dock")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dk_code),expression:"dk_code"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":true},domProps:{"value":(_vm.dk_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dk_code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-6 p-r-0 mb-2 mt-2 d-grid gap-2"},[_c('label',{staticStyle:{"font-weight":"bold"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm btn-sm-fix",attrs:{"type":"button","disabled":this.prs_ids.length === 0},on:{"click":function($event){_vm.active_page = 1
              _vm.addStockOut()}}},[_vm._v("\n            Stock Out\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-2 pb-2"},[_c('div',{staticClass:"col-md-6 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Kanban Information")]),_vm._v(" "),_c('table',{staticClass:"table customize-table mb-0 v-middle",staticStyle:{"border":"1px"}},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(this.aisin))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(this.read))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(this.ordered))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(this.current))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(this.setup))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(this.kbwait))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{ref:"javascript:void(0)",staticClass:"btn btn-link",attrs:{"data-bs-toggle":"modal","data-bs-target":"#KBSEditModal"}},[_vm._v("Edit")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive tableFixHead"},[_c('table',{staticClass:"table customize-table mb-0 v-middle"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.isLoad == true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"13"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),_vm._l((_vm.result_data),function(rs,i){return _c('tr',{key:'rs' + i},[_c('td',{staticClass:"text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prs_ids),expression:"prs_ids"}],attrs:{"type":"checkbox","disabled":rs.prs_inout != 1 || rs.prs_remark === '' || rs.cycle_check == 1 ? true : false},domProps:{"value":rs.prs_id,"checked":Array.isArray(_vm.prs_ids)?_vm._i(_vm.prs_ids,rs.prs_id)>-1:(_vm.prs_ids)},on:{"change":function($event){var $$a=_vm.prs_ids,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=rs.prs_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.prs_ids=$$a.concat([$$v]))}else{$$i>-1&&(_vm.prs_ids=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.prs_ids=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-start"},[_vm._v(_vm._s(rs.serial))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(rs.prs_inout == 1 ? 'IN' : 'OUT'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.dateFormatAndTime(rs.prs_in_time)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(rs.prs_inout == 1 ? ' ' : _vm.dateFormatAndTime(rs.prs_out_time)))]),_vm._v(" "),(rs.cycle_check == 1 || rs.prs_inout == 0)?_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge fw-normal bg-light-danger text-danger"},[_vm._v("No cycle")])]):_c('td',{staticClass:"text-center"},[_vm._v("\n                "+_vm._s(rs.cycle_name)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-start"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(rs.prs_remark),expression:"rs.prs_remark"}],staticClass:"form-select form-select-sm",staticStyle:{"width":"100%"},attrs:{"id":"select2-remark"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(rs, "prs_remark", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateRemark(rs.prs_id, rs.prs_remark)}]}},[_c('option',{attrs:{"value":""}}),_vm._v(" "),_vm._l((_vm.remarkList),function(rm,i){return _c('option',{key:'irm' + i,domProps:{"value":rm.prs_remark}},[_vm._v(" "+_vm._s(rm.prs_remark)+" ")])})],2)])])}),_vm._v(" "),(_vm.result_data.length < 1 && _vm.isLoad == false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"13"}},[_vm._v("No Data")])]):_vm._e()],2)])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"KBSEditModal","data-backdrop":"static","data-keyboard":"false","tabindex":"-1","aria-labelledby":"KBSEditModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-fullscreen-md-down modal-xl modal-dialog-centered modal-dialog-scrollable"},[_c('kbseditmodal',{attrs:{"md_data":_vm.md_data,"search":_vm.search}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Aisin")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Read")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Ordered")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Total (Current)")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Setup")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("KB Adjust Waiting")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top text-center",attrs:{"width":"4%"}},[_vm._v("Select")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center",attrs:{"width":"2%"}},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-start",attrs:{"width":"25%"}},[_vm._v("Serial QR Code")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center",attrs:{"width":"4%"}},[_vm._v("IN/OUT")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center",attrs:{"width":"14%"}},[_vm._v("IN Time")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center",attrs:{"width":"14%"}},[_vm._v("OUT Time")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center",attrs:{"width":"14%"}},[_vm._v("Cycle")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-start"},[_vm._v("Remark")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.c0a312985ff40f9d28d5.js